import { render, staticRenderFns } from "./BidComponent.vue?vue&type=template&id=4e664915&"
import script from "./BidComponent.vue?vue&type=script&lang=js&"
export * from "./BidComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports